export function ensurePaddingRange(value, range = {}) {
  const { min, max } = range;

  if (!value) {
    return 0;
  }

  return Math.max(min, Math.min(max, value));
}
